module.exports = __webpack_public_path__ + "img/motorboat.3ce259f0.jpg";